import { render } from "./xfs.vue?vue&type=template&id=5adfa61c&scoped=true"
import script from "./xfs.vue?vue&type=script&lang=js"
export * from "./xfs.vue?vue&type=script&lang=js"

import "./xfs.vue?vue&type=style&index=0&id=5adfa61c&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adfa61c"]])

export default __exports__